module.exports = __webpack_public_path__ + "img/h2.82e8e117.svg";